import * as React from "react";
import { Navigate } from "react-router-dom";
import { useMe } from "../hooks/useMe.js";
import { LoadingSpinner } from "./LoadingSpinner.js";
import { NotFoundRoute } from "../routes/NotFoundRoute.js";

/**
 * Route guard that restricts children to users with a non-null staff_role.
 *
 * Loading  -> spinner
 * Anon     -> redirect to /signin
 * No role  -> renders NotFoundRoute (hides existence of the page)
 * Has role -> renders children
 */
export function RequireStaff({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const { data: me, loading } = useMe();

  if (loading) {
    return <LoadingSpinner label="Loading…" />;
  }

  if (!me?.user) {
    return <Navigate to="/signin" replace />;
  }

  if (!me.user.staff_role) {
    return <NotFoundRoute />;
  }

  return <>{children}</>;
}
